<template>
  <div class="canvasContainer">
    <canvas id="pacmanCanvas"></canvas>
  </div>
</template>

<script>
import apiClientCreator from "../../../../helpers/api/request";
export default {
  name: "Pacman.container",

  created() {
    window && window.addEventListener("message", this.saveScore, false);
  },

  mounted() {
    let scriptTag = document.createElement("script");
    scriptTag.setAttribute("src", "/js/pacman.js");
    document.head.appendChild(scriptTag);
  },

  data() {
    return {
      // src: "https://gabmic.github.io/pacman/pacman.js",
      src: "/js/pacman.js"
    };
  },

  methods: {
    saveScore({ data }) {
      apiClientCreator(`users/score`)
        .post("", { score: data, game: "PACMAN" })
        .then(res => {
          return res;
        });
    }
  }
};
</script>

<style scoped>
.canvasContainer {
  /*margin: 0.5rem;*/
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: max-content;
  overflow: hidden;
}
</style>
